export default __webpack_public_path__ + "static/media/bookcase.feff5a30.png";